import * as Sentry from '@sentry/react';
import { SENTRY_URL } from 'base/constants';
import { configure } from 'mobx';
import { getUserId } from '../../library/src/modules/cookies';
import './global.css';
import { ASYNC_GENERATOR_ERROR_SYMBOL } from './llm_proxy_service';

const ignoreErrors =
  window.location.host.includes('localhost') ||
  window.location.hostname === 'relume-library.webflow.io';

Sentry.init({
  dsn: SENTRY_URL,
  enabled: !ignoreErrors,
  denyUrls: [/^chrome-extension:\/\//i],
  beforeSend(event, hint) {
    const exc = hint.originalException as any;
    if (exc && typeof exc === 'object' && ASYNC_GENERATOR_ERROR_SYMBOL in exc) {
      console.info('Async generator error, not sending to Sentry');
      return null;
    }
    return event;
  },
  ignoreErrors: [
    'AbortError: The user aborted a request.',
    // Most often a network blip on the user's end:
    'TypeError: Failed to fetch',
    'TypeError: NetworkError when attempting to fetch resource.',
  ],
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
  ],
  // Trace 2% of requests.
  tracesSampleRate: 0.02,
  // Profile .05% of traced requests (0.005% of all requests).
  profilesSampleRate: 0.0005,
  tracePropagationTargets: ['apis.relume.io', 'staging-apis.relume.io'],
});
configure({ enforceActions: 'never' });

try {
  Sentry.setUser({ id: getUserId() });
} catch {}
